import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  cpfCnpj: Yup.string().required("*O CNPJ é obrigatório"),
});

export default validationSchema;
